import { useSelector } from 'react-redux';
import useFetchSingleProvider from '~/components/ProviderGroup/hooks/useFetchSingleProvider';
import { isProviderGroupBooking } from '~/core/util/booking';
import { isEmpty } from '../../../core/util/empty';
import useSelectAppointment from '../components/GetCare/hooks/useSelectAppointment';

/**
 * @returns the upcoming appointment
 */
export default function useUpcomingAppointment(userProfileId: string) {
  const isFetching = useSelector((state: any) => state.account.accountAppointmentsFetching);

  const { appointment } = useSelectAppointment(userProfileId);
  const { provider } = useFetchSingleProvider(appointment?.provider_id);

  const ignoreAppointment = isProviderGroupBooking(appointment) && isEmpty(provider);

  return {
    isFetching,
    appointment: ignoreAppointment ? null : appointment,
  };
}
